export const multipleChoiceQuestions = [
  {
    id: 1,
    question: "Ποιες περιοχές περιλάμβανε το ελληνικό κράτος μετά την επίσημη αναγνώριση της ανεξαρτησίας του το 1830;",
    options: [
      "Πελοπόννησο, Στερεά Ελλάδα και Κυκλάδες",
      "Πελοπόννησο, Θεσσαλία και Ήπειρο",
      "Στερεά Ελλάδα, Μακεδονία και Θράκη",
      "Κρήτη, Πελοπόννησο και Επτάνησα"
    ],
    correctAnswer: 0,
    feedbackCorrect: "Σωστά! 🎉 Μετά την επίσημη αναγνώριση της ανεξαρτησίας της το 1830, η Ελλάδα περιλάμβανε μόνο την Πελοπόννησο, τη Στερεά Ελλάδα και τις Κυκλάδες, με σύνορα στη γραμμή Αμβρακικού-Παγασητικού.",
    feedbackIncorrect: "Λάθος! ❌ Η σωστή απάντηση είναι: Πελοπόννησο, Στερεά Ελλάδα και Κυκλάδες. Το νεοσύστατο ελληνικό κράτος ήταν περιορισμένο γεωγραφικά, με σύνορα στη γραμμή Αμβρακικού-Παγασητικού."
  },
  {
    id: 2,
    question: "Πώς εξελίχθηκε η πυκνότητα του πληθυσμού στην Ελλάδα από το 1828 έως το 1911;",
    options: [
      "Παρέμεινε σταθερή στους 15 κατοίκους/τ.χλμ.",
      "Αυξήθηκε από 15 σε 43 κατοίκους/τ.χλμ.",
      "Μειώθηκε από 43 σε 15 κατοίκους/τ.χλμ.",
      "Αυξήθηκε από 15 σε 100 κατοίκους/τ.χλμ."
    ],
    correctAnswer: 1,
    feedbackCorrect: "Σωστά! 🎉 Η πυκνότητα του πληθυσμού στην Ελλάδα αυξήθηκε από 15 κατοίκους/τ.χλμ. το 1828 σε 43 κατοίκους/τ.χλμ. το 1911, αν και παρέμενε χαμηλότερη σε σύγκριση με τις χώρες της Δυτικής Ευρώπης.",
    feedbackIncorrect: "Λάθος! ❌ Η σωστή απάντηση είναι: Αυξήθηκε από 15 σε 43 κατοίκους/τ.χλμ. Η Ελλάδα ήταν μια αραιοκατοικημένη χώρα με πληθυσμό που αυξανόταν με γρήγορους ρυθμούς, αλλά παρέμενε πίσω από τις χώρες της Δυτικής Ευρώπης."
  },
  {
    id: 3,
    question: "Ποιο γεγονός αποτέλεσε καταλύτη για τη μετανάστευση Ελλήνων προς την Αμερική στα τέλη του 19ου αιώνα;",
    options: [
      "Ο Κριμαϊκός Πόλεμος",
      "Η σταφιδική κρίση",
      "Η προσάρτηση της Θεσσαλίας",
      "Η βιομηχανική επανάσταση"
    ],
    correctAnswer: 1,
    feedbackCorrect: "Σωστά! 🎉 Η σταφιδική κρίση στα τέλη του 19ου αιώνα αποτέλεσε καταλύτη για τη μετανάστευση πολλών Ελλήνων, κυρίως από την Πελοπόννησο, προς την Αμερική, καθώς αναζητούσαν καλύτερες συνθήκες ζωής.",
    feedbackIncorrect: "Λάθος! ❌ Η σωστή απάντηση είναι: Η σταφιδική κρίση. Αυτή η οικονομική κρίση οδήγησε πολλούς αγρότες, κυρίως από την Πελοπόννησο, να αναζητήσουν καλύτερες συνθήκες ζωής στην Αμερική."
  },
  {
    id: 4,
    question: "Ποιοι ήταν οι βασικοί περιορισμοί της ελληνικής οικονομίας μετά την ανεξαρτησία;",
    options: [
      "Υπερπληθυσμός και έλλειψη γης",
      "Υψηλή φορολογία και διεθνείς κυρώσεις",
      "Έλλειψη πρώτων υλών και περιορισμένη εσωτερική αγορά",
      "Υπερβολική εξάρτηση από τη ναυτιλία και το εμπόριο"
    ],
    correctAnswer: 2,
    feedbackCorrect: "Σωστά! 🎉 Οι βασικοί περιορισμοί της ελληνικής οικονομίας περιλάμβαναν την έλλειψη σημαντικών πρώτων υλών, την έλλειψη εξειδικευμένου εργατικού δυναμικού, την ισχνή συσσώρευση κεφαλαίου και την περιορισμένη εσωτερική αγορά.",
    feedbackIncorrect: "Λάθος! ❌ Η σωστή απάντηση είναι: Έλλειψη πρώτων υλών και περιορισμένη εσωτερική αγορά. Η Ελλάδα αντιμετώπιζε επίσης έλλειψη εξειδικευμένου εργατικού δυναμικού και ισχνή συσσώρευση κεφαλαίου, τόσο ιδιωτικού όσο και δημόσιου."
  },
  {
    id: 5,
    question: "Πώς επηρέασε η \"Μεγάλη Ιδέα\" την οικονομική ανάπτυξη της Ελλάδας;",
    options: [
      "Ενίσχυσε την οικονομική ανάπτυξη λόγω αυξημένων επενδύσεων στον στρατό",
      "Δεν είχε καμία επίδραση στην οικονομία",
      "Οδήγησε σε οικονομική απομόνωση από τις ευρωπαϊκές δυνάμεις",
      "Έκανε τις οικονομικές πρωτοβουλίες έρμαια των εθνικών κρίσεων"
    ],
    correctAnswer: 3,
    feedbackCorrect: "Σωστά! 🎉 Η \"Μεγάλη Ιδέα\" και η συνύφανσή της με το εθνικό όραμα αύξησε το κόστος των οικονομικών προσπαθειών και κατέστησε συχνά τις οικονομικές πρωτοβουλίες έρμαια των εθνικών κρίσεων.",
    feedbackIncorrect: "Λάθος! ❌ Η σωστή απάντηση είναι: Έκανε τις οικονομικές πρωτοβουλίες έρμαια των εθνικών κρίσεων. Η έντονη παρουσία της εθνικής ιδεολογίας είχε σημαντικές επιπτώσεις στον οικονομικό χώρο, καθώς οι κυβερνήσεις έπρεπε να συμβιβάσουν τις εσωτερικές ανάγκες οικονομικής ανάπτυξης με τις εξωτερικές εθνικές διεκδικήσεις."
  }
];

export const trueFalseQuestions = [
  {
    id: 6,
    question: "Οι Έλληνες που ζούσαν εκτός των συνόρων του ελληνικού κράτους θεωρούσαν εξαρχής το ελληνικό βασίλειο ως σημαντικό κέντρο του ελληνισμού.",
    isTrue: false,
    feedbackCorrect: "Σωστά! 🎉 Για τους Έλληνες των περιοχών εκτός συνόρων, το μικρό ελληνικό βασίλειο ήταν για πολλά χρόνια \"μια κακή ανάμνηση, ένας φτωχός και ίσως ανεπρόκοπος συγγενής\". Μόνο όταν δυσκόλεψαν οι συνθήκες γι' αυτούς προς το τέλος του 19ου αιώνα, ανακάλυψαν τη σημασία της πατρίδας τους.",
    feedbackIncorrect: "Λάθος! ❌ Στην πραγματικότητα, για τους Έλληνες των περιοχών εκτός συνόρων, το μικρό ελληνικό βασίλειο θεωρούνταν για πολλά χρόνια \"ένας φτωχός και ίσως ανεπρόκοπος συγγενής\". Η στάση τους άλλαξε μόνο προς το τέλος του 19ου αιώνα, όταν οι συνθήκες έγιναν δυσμενείς γι' αυτούς."
  },
  {
    id: 7,
    question: "Οι ελληνικές πόλεις του 19ου αιώνα είχαν παρόμοια ανάπτυξη με τα βιομηχανικά και εμπορικά κέντρα της Δυτικής Ευρώπης.",
    isTrue: false,
    feedbackCorrect: "Σωστά! 🎉 Οι ελληνικές πόλεις μεγάλωναν μεν σταδιακά, αλλά σε σύγκριση με τα βιομηχανικά, εμπορικά και χρηματιστικά κέντρα της Δύσης, έμοιαζαν περισσότερο με μεγάλα χωριά και είχαν περιορισμένες οικονομικές δυνατότητες.",
    feedbackIncorrect: "Λάθος! ❌ Οι ελληνικές πόλεις του 19ου αιώνα, παρά τη σταδιακή ανάπτυξή τους, έμοιαζαν περισσότερο με μεγάλα χωριά σε σύγκριση με τα ανεπτυγμένα βιομηχανικά, εμπορικά και χρηματιστικά κέντρα της Δυτικής Ευρώπης."
  },
  {
    id: 8,
    question: "Κατά τη διάρκεια του Κριμαϊκού Πολέμου (1854), ο ναυτικός αποκλεισμός από τους Αγγλο-Γάλλους επιβεβαίωσε τις ισχυρές οικονομικές δυνατότητες της Ελλάδας.",
    isTrue: false,
    feedbackCorrect: "Σωστά! 🎉 Αντίθετα, ο ναυτικός αποκλεισμός από τους Αγγλο-Γάλλους κατά τη διάρκεια του Κριμαϊκού Πολέμου προκάλεσε πείνα, αρρώστιες και ανθρώπινες απώλειες, επιβεβαιώνοντας τις μικρές δυνατότητες της χώρας.",
    feedbackIncorrect: "Λάθος! ❌ Ο ναυτικός αποκλεισμός από τους Αγγλο-Γάλλους κατά τη διάρκεια του Κριμαϊκού Πολέμου (1854) προκάλεσε πείνα, αρρώστιες και ανθρώπινες απώλειες, επιβεβαιώνοντας τις μικρές δυνατότητες της χώρας και όχι την οικονομική της ισχύ."
  },
  {
    id: 9,
    question: "Η μετακίνηση του αγροτικού πληθυσμού προς τα αστικά κέντρα της Ελλάδας οδηγούσε συνήθως σε μόνιμη εγκατάσταση λόγω των πολλών ευκαιριών απασχόλησης.",
    isTrue: false,
    feedbackCorrect: "Σωστά! 🎉 Η μετακίνηση ανθρώπων από την ύπαιθρο προς τα αστικά κέντρα δεν οδηγούσε πάντα σε μόνιμη εγκατάσταση, καθώς η αργή ανάπτυξη των παραγωγικών δραστηριοτήτων και η έλλειψη βιομηχανικής ανάπτυξης δεν προσέφεραν πολλές ευκαιρίες.",
    feedbackIncorrect: "Λάθος! ❌ Στην πραγματικότητα, η μετακίνηση από την ύπαιθρο προς τα αστικά κέντρα συχνά δεν οδηγούσε σε μόνιμη εγκατάσταση, επειδή η αργή ανάπτυξη των παραγωγικών δραστηριοτήτων και η έλλειψη βιομηχανικής ανάπτυξης δεν προσέφεραν πολλές ευκαιρίες στους νεοφερμένους."
  },
  {
    id: 10,
    question: "Οι ελληνικές κυβερνήσεις του 19ου αιώνα είχαν στραμμένο το ενδιαφέρον τους αποκλειστικά στα εσωτερικά οικονομικά ζητήματα και την ανάπτυξη.",
    isTrue: false,
    feedbackCorrect: "Σωστά! 🎉 Οι ελληνικές κυβερνήσεις δεν είχαν στραμμένο το ενδιαφέρον τους αποκλειστικά στα εσωτερικά ζητήματα, αλλά έπρεπε να συμβιβάσουν την οικονομική ανόρθωση με το εθνικό όραμα της \"Μεγάλης Ιδέας\", γεγονός που επηρέαζε σημαντικά τις οικονομικές αποφάσεις.",
    feedbackIncorrect: "Λάθος! ❌ Οι ελληνικές κυβερνήσεις έπρεπε να συμβιβάσουν τις εσωτερικές ανάγκες οικονομικής ανάπτυξης με τις εξωτερικές εθνικές διεκδικήσεις της \"Μεγάλης Ιδέας\". Αυτή η διπλή πρόκληση καθόρισε σε μεγάλο βαθμό την οικονομική πορεία της χώρας."
  }
];
